import "./widgetLg.css";
import React,{ useState, useEffect } from "react";
import { getErrands } from "../../Data/Errands";


export default function WidgetLg() {
  const [AllErrands, setErrands] = useState([]);

  useEffect(() => {
    const fetchErrands = async () => {
      const Errands = await getErrands();
      setErrands(
        Errands.docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );
    };
    return fetchErrands();
  }, [AllErrands]);
  return (
    <div className="widgetLg">
      <h3 className="widgetLgTitle">Errands</h3>
      <center>
        {" "}
        <p style={{ color: "goldenrod", fontSize: "50px" }}>
          {AllErrands.length}
        </p>
      </center>
    </div>
  );
}
